<template>
  <input-select
    v-model="conta"
    :search="pesquisaConta"
    :options="contas"
    :disabled="disabled"
    :required="required"
    @input="emiteInput"
    placeholder="Todas"
  />
</template>

<script>
export default {
  data () {
    return {
      conta: null,
      contaAnterior: null,
      contas: []
    }
  },
  props: {
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    codigoOperadorFrontEnd: String,
    codigoParceiro: String,
    codigoAgencia: String
  },
  watch: {
    codigoOperadorFrontEnd (val) {
      this.reload()
    },
    codigoParceiro (val, oldVal) {
      this.reload()
    },
    codigoAgencia (val, oldVal) {
      this.reload()
    }
  },
  methods: {
    emiteInput (val) {
      if (this.contaAnterior !== val) {
        this.$emit('input', val)
      }
      this.contaAnterior = val
    },
    carregaContas (numeroConta, codigoConta) {
      const th = this
      this.contas = []

      if (!numeroConta && th.conta) numeroConta = th.conta.text

      let dto = {
        parameters: [
          {
            name: 'codigoOperadorFrontEnd',
            value: this.codigoOperadorFrontEnd
          },
          { name: 'codigoParceiro', value: this.codigoParceiro },
          { name: 'codigoAgencia', value: this.codigoAgencia },
          { name: 'numeroConta', value: numeroConta }
        ]
      }

      th.$api.Contas.ComboContas(dto).then(function (data) {
        if (!data.length || data.length === 0) {
          th.$api.UI.ShowError(
            'Erro',
            'Não foram encontradas contas com os parâmetros informados.'
          )
        } else {
          data.forEach(function (item) {
            th.contas.push({
              value: item.codigo,
              text: item.contaPgto,
              contaPgto: th.$api.UI.Format.ContaPgto(item.contaPgto),
              descricao: item.descricao,
              tipoConta: item.tipoConta,
              numero: item.numero,
              digito: item.digito
            })
          })

          if (codigoConta) {
            th.conta = th.contas.find(c => c.value === codigoConta)
          }
        }
      })
    },
    reload () {
      this.conta = null
      this.carregaContas()
    }
  },
  beforeMount () {
    this.carregaContas()
  },
  created () {
    // eslint-disable-next-line no-undef
    this.pesquisaConta = _.debounce(this.carregaContas, 300)
  }
}
</script>
